export enum GraphqlVariables {
  HTTP = 'http://localhost:4000/graphql',
  WS = 'ws://localhost:4000/graphql',
  OPERATION_DEFINITION = 'OperationDefinition',
  SUBSCRIPTION = 'subscription'
}
